import { Counterparty } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/SendDocumentModal/types';
import { useCommonYupValidation } from '@dealstack/frontend/shared/other/react/form/useCommonYupValidation';
import { generateUUID } from '@dealstack/frontend/shared/other/react/generateUUID';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';

export enum COUNTERPARTY_FORM {
	NAME = 'name',
	AMOUNT = 'amount',
}

interface CounterpartyInputsValues {
	[COUNTERPARTY_FORM.NAME]: string;
	[COUNTERPARTY_FORM.AMOUNT]: number;
}

export const INPUT_MIN_AMOUNT = 1;
export const INPUT_MAX_AMOUNT = 6;
export const INPUT_STEP = 1;
export const COUNTERPARTY_FORM_DEFAULT_VALUE = {
	[COUNTERPARTY_FORM.NAME]: '',
	[COUNTERPARTY_FORM.AMOUNT]: INPUT_STEP,
};
export const useCounterpartiesFormController = (
	addCounterparty: (counterparty: Counterparty) => void
) => {
	const commonYup = useCommonYupValidation();

	const validationSchema = Yup.object().shape({
		[COUNTERPARTY_FORM.NAME]: commonYup.inputPersonNameString.required,
		[COUNTERPARTY_FORM.AMOUNT]: commonYup.number.required,
	});

	const counterpartyForm = useForm({
		mode: 'onSubmit',
		defaultValues: COUNTERPARTY_FORM_DEFAULT_VALUE,
		resolver: yupResolver(validationSchema),
	});

	const onSubmit = (formData: CounterpartyInputsValues) => {
		const data = {
			chipId: generateUUID(),
			name: formData[COUNTERPARTY_FORM.NAME],
			amount: formData[COUNTERPARTY_FORM.AMOUNT],
		};
		addCounterparty(data);
		counterpartyForm.reset();
	};

	return { counterpartyForm, onSubmit };
};
